<template>
  <div>
    <Post v-if="componentRenderStatus.post" :postData="{ ...data, postId: data.id }" :fromShare="true" :commentId="commentId" />
    <Post
      v-if="componentRenderStatus.job"
      :postData="{ ...data.user_job, content_type: data.content_type, postId: data.id, sponsered: data.sponsered, user: [data.user_job.user], allow_comments: data.allow_comments }"
      :commentId="commentId"
      :fromShare="true"
    />
    <Post
      v-if="componentRenderStatus.press"
      :postData="{ ...data.user_press, content_type: data.content_type, postId: data.id, sponsered: data.sponsered, user: [data.user_press.user], allow_comments: data.allow_comments }"
      :fromShare="true"
      :commentId="commentId"
    />
    <Post
      v-if="componentRenderStatus.event"
      :postData="{ ...data.user_event, content_type: data.content_type, postId: data.id, sponsered: data.sponsered, user: [data.user_event.user], allow_comments: data.allow_comments }"
      :commentId="commentId"
      :fromShare="true"
    />
    <UserPoll v-if="componentRenderStatus.poll" :pollData="{ ...data.user_poll, postId: data.id }" :fromShare="true" :commentId="commentId" />
    <IndividualReviewCard v-if="componentRenderStatus.review" :reviewData="data" :showAllreviewsButton="false" />
    <RecommendCard v-if="componentRenderStatus.recommend" :reviewData="data" :showViewAllBtn="false" />
    <Question v-if="componentRenderStatus.question" :quesData="data.user_question" :fromShare="true" :commentId="commentId" />
    <div class="flex-center-center flex-column gap8 p-4 bg-gray100 br8" v-if="!isLoading && !data">
      <font-awesome-icon :icon="['fas', 'search']" :style="{ color: getPrimary300Color() }" class="font20 bg-white p-4 rounded-circle" />
      <h5 class="gray900 fw700 font20 mb-0">No Results Found</h5>
      <p class="mb-0 gray700 font14">The post you are searching for could not be found.</p>
    </div>
    <!-- <Article v-if="componentRenderStatus.article" :articleData="data"></Article>
    <Quiz v-if="componentRenderStatus.quiz" :quizData="data"></Quiz>
    <Video v-if="componentRenderStatus.video" :videoData="data"></Video> -->
  </div>
</template>

<script>
// import Article from './contents/Article'
// import Quiz from '../quiz/Quiz'
// import Video from './contents/Video'
// import Slideshow from './contents/Slideshow'
import Question from "../Users/Patient/QA/Question"
import Post from "../home/Post"
import UserPoll from "../home/poll/UserPollCard.vue"
import { RepositoryFactory } from "../../repositories/RepositoryFactory"
import IndividualReviewCard from "../home/reviews/ReviewTabCard.vue"
import RecommendCard from "../home/Recommended/RecommendCard.vue"

// const ResourceRepository = RepositoryFactory.get("resource")
// const QARepository = RepositoryFactory.get("qa")
const PostRepository = RepositoryFactory.get("posts")
const ReviewsRepository = RepositoryFactory.get("reviews")

export default {
  name: "ResourceView",
  data() {
    return {
      type: null,
      id: null,
      commentType: null,
      commentId: null,
      data: null,
      componentRenderStatus: {
        article: false,
        event: false,
        job: false,
        poll: false,
        post: false,
        press: false,
        question: false,
        quiz: false,
        slideshow: false,
        video: false,
        review: false,
        recommend: false,
      },
    }
  },
  components: {
    Post,
    UserPoll,
    Question,
    IndividualReviewCard,
    RecommendCard,
  },

  created() {
    console.warn("Share.vue is created")
    this.fetchResource()
  },

  watch: {
    "$route.params": {
      handler() {
        console.log("$route.params:", this.$route.params)
        this.fetchResource()
      },
      // immediate: true,
      deep: true,
    },
    // id: {
    //   handler(v) {
    //     if (v) {
    //       this.fetchResource()
    //     }
    //   },
    //   immediate: true,
    // },
  },

  methods: {
    fetchResource() {
      this.type = this.$route.params.type
      this.id = this.$route.params.id
      this.commentType = this.$route.params.cmnttype
      this.commentId = this.$route.params.cmntid
      // console.log("type ->", this.type)
      // console.log("id ->", this.id)
      // console.log("Comment type ->", this.commentType)
      // console.log("Comment id ->", this.commentId)
      this.setAppLoaderStatus(true)
      // this.getResourceFunction()
      //   .then(res => {
      //     this.data = res.data.data.data.length ? res.data.data.data[0] : null
      //     console.log("res data ->", this.data)
      //     this.componentRenderStatus[this.type] = true
      //     this.setAppLoaderStatus(false)
      //   })
      //   .catch(err => {
      //     this.setAppLoaderStatus(false)
      //   })
      // if (this.type === "poll") {
      //   ResourceRepository.getPoll(this.id, 1, 1, this.currentCircle.id)
      //     .then(res => {
      //       // this.poll = res.data.data.data[0]
      //       this.data = res.data.data.data.length ? res.data.data.data[0] : null
      //       this.componentRenderStatus.poll = true
      //       this.setAppLoaderStatus(false)
      //     })
      //     .catch(e => {
      //       this.setAppLoaderStatus(false)
      //     })
      // } else {
      // PostRepository.getById(this.id, this.currentCircle.id)
      //   .then(res => {
      //     this.data = res.data.data.data.length ? res.data.data.data[0] : null
      //     console.log("res data ->", this.data)
      //     this.componentRenderStatus[this.type] = true
      //     this.setAppLoaderStatus(false)
      //   })
      //   .catch(e => {
      //     this.setAppLoaderStatus(false)
      //   })
      // }
      this.componentRenderStatus = {
        article: false,
        event: false,
        job: false,
        poll: false,
        post: false,
        press: false,
        question: false,
        quiz: false,
        slideshow: false,
        video: false,
        review: false,
        recommend: false,
      }
      if (["review", "recommend"].includes(this.type)) {
        ReviewsRepository.getReviewFromId(this.id)
          .then(r => {
            // console.log("res:", r)
            this.data = r.data.data.length ? r.data.data[0] : null
            this.componentRenderStatus[this.type] = true
            this.setAppLoaderStatus(false)
          })
          .catch(e => {
            this.setAppLoaderStatus(false)
          })
      } else {
        // PostRepository.getAllTypeById(this.getDovemedPostApiIdName(this.type), this.id, this.currentCircle.id)
        PostRepository.getAllTypeByIdForNoti(this.getDovemedPostApiIdName(this.type), this.id, this.currentCircle.id)
          .then(res => {
            // console.log("res:", res)
            this.data = res.data.data.data.length ? res.data.data.data[0] : null
            // console.log("api data ->", this.data)
            this.componentRenderStatus[this.type] = true
            this.setAppLoaderStatus(false)
          })
          .catch(e => {
            this.setAppLoaderStatus(false)
          })
      }
    },

    // getResourceFunction() {
    // switch (this.type) {
    // case "article":
    //   return ResourceRepository.getarticle(this.id)
    // case "quiz":
    //   return ResourceRepository.getquiz(this.id)
    // case "poll":
    //   return ResourceRepository.getpoll(this.id, 1, 5, this.currentCircle.id)
    // case "video":
    //   return ResourceRepository.getarticle(this.id)
    // case "slideshow":
    //   return ResourceRepository.getarticle(this.id)
    // case "poll":
    // case "post":
    // case "job":
    // case "press":
    // case "event":
    //   return PostRepository.getById(this.id, this.currentCircle.id)
    // case "qa":
    //   return QARepository.getQuestionById(this.currentCircle.id, 1, 1, this.id)
    // default:
    // break
    // }
    // },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/commons/Share.vue